import React, { Component } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { createStyles, withStyles } from '@material-ui/core/styles';

import isPresent from '../../../Common/Utils/Present';
import JsFunction from './JsFunction';

const styles = createStyles({
  dialog: {
    width: '90%',
    height: '90%',
    maxWidth: '90%',
    maxHeight: '90%'
  },
  dialogContent: {
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '100%'
  },
  raisedButton: {
    margin: '10px 24px',
    position: 'relative'
  }
});

type Props = {
  attribute_name: string,
  classes: any,
  index: number,
  label: string,
  prefix: string,
  record: any
};

type StateProps = {
  open: boolean
};

class AdUnitRender extends Component<Props, StateProps> {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClick = () => {
    this.setState({ open: false });
  };

  render() {
    let title = '';
    if (this.props.record && this.props.record.ad_units && this.props.record.ad_units[this.props.index]) {
      title = this.props.record.ad_units[this.props.index].div_id + ' -';
    }

    let color = null;
    if (
      this.props.record &&
      this.props.record.ad_units &&
      this.props.record.ad_units[this.props.index] &&
      (
        (this.props.record.ad_units[this.props.index][this.props.attribute_name] &&
          isPresent(this.props.record.ad_units[this.props.index][this.props.attribute_name].jsfunction)
        ) ||
        isPresent(this.props.record.ad_units[this.props.index][`${this.props.attribute_name}_custom`])
      )
    ) {
      color = 'primary';
    }

    return (
      <div>
        <Button
          onClick={this.handleOpen}
          variant="raised"
          color={color}
          className={this.props.classes.raisedButton}>{this.props.label}
        </Button>
        <Dialog
          open={this.state.open}
          maxWidth="md"
          fullWidth={true}
          className={this.props.classes.dialog}
        >
          <DialogTitle>{`${title} ${this.props.label}`}</DialogTitle>
          <DialogContent className={this.props.classes.dialogContent}>
            <JsFunction
              attribute_name={this.props.attribute_name}
              index={this.props.index}
              prefix={`${this.props.prefix}.${this.props.attribute_name}`}
              record={this.props.record} />
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={this.handleClick}>Ok</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
};

export default withStyles(styles)(AdUnitRender);



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/AdUnitRender.tsx